/* global jQuery, closeTheStage */

// Close the preload form after submit form
jQuery(document).ready(function(){
	var $ = jQuery;
	// Agent Carousel
	var carousel = $('.agent-carousel');
	
	
	$('.overlay-box').css('display','block');
	
	//setWidthPlayer();
    
    // Improve UX for carousel: hide all 
    // Setup height for carousel div
    //carousel.closest('.wraper').css('height', carousel.children('div:eq(0)').outerHeight() + 230);
    
    // Improve UX: Display children item in carousel after js loaded
    carousel.children('div').css('visibility', 'visible');
    
    carousel.slick({
    	arrows: true,
    	dots: true,
		infinite: false,
		speed: 1000,
		slidesToShow: 1,
		adaptiveHeight: true,
		autoplay: true
	});
	var idPreloaderForm = jQuery('#preloader_form_id').val();
	$('#gform_submit_button_'+idPreloaderForm).click(function(){
		closeTheStage();
	});

	setupSidebarForm();
	
	// Fix gallery
    $('.gallery-popup').each(function() {
         jQuery(this).magnificPopup({
			delegate: 'a',
			type: 'image',
			gallery: {
				enabled:true
			}
         });
    });
	
	// Pause slick after the first spin
	setTimeout("jQuery('.agent-carousel').slick('slickPause');", 1500);
	
	$('.toggle-button').click(function(event) {
		event.preventDefault();
		$('body').toggleClass('full');
	});
});

//Set width .player
function setWidthPlayer(){
	var $ = jQuery;
	var sidebar = $('.mask');
	var player	= $('.player');
	var windowWidth = $(window).innerWidth();
	// Update player's width to make the sidebar not overlapping it.
	if(player.data('overlap') == false) {
		//sidebar.css('right', (60 - player.data('position')) + 'px');
		player.width(windowWidth - 62);
	}
}

// In these functions, I use Gravity Forms ID to modify forms in showcase single page, we can change ID number in different websites
function setupSidebarForm() {
	var $ = jQuery;
	var idAgentSidebar = $('#agent_sidebar_id').val();
	var form = $('#gform_'+idAgentSidebar);
	$('gform_ajax_spinner_'+idAgentSidebar).css('display','none');
	// Show the sidebar using js to improve UX
	$('.mask').show();
}

jQuery(window).resize(function() {
	//setWidthPlayer();
});


// jQuery(window).on('load', function() {
	// var $ = jQuery;
	// var carousel = $('.agent-carousel');
	// carousel.closest('.wraper').css('height', carousel.children('div:eq(0)').outerHeight() + 230);
// });